export default __webpack_public_path__ + "static/media/05_photo.dea06a68.jpeg";